import { ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import EducationCustomerSupport from "./app/educationDashbaord/customerSupport";
// import SupplierSalesDetail from "./app/supplierDashboard/catalogue/SalesDetail";
// import AllReviews from "./app/supplierDashboard/clients/AllReviews";
import i18n from "i18next";
import { SnackbarProvider } from "notistack";
import { initReactI18next } from "react-i18next";
import { useSelector } from "react-redux";
import CompanyAllServicesPage from "./app/companyDashboard/subscription/AllServices";
import AdminCustomerSupport from "./app/supplierDashboard/customorSupport";
import SupplierSalesDetail from "./app/supplierDashboard/order/SalesDetail";
import CreatorCampaignDetail from "./app/creatorDashboard/campaigns/CampaignDetail";
import SnackbarAlert from "./components/Snackbar";
import { snackConst } from "./constants/Variables";
import useRoleWiseRoutes, {
  isCreatorUnderReview,
} from "./hooks/useRoleWiseRoutes";
import { AuthRoutes } from "./routes";
import { ProtectedLayout } from "./routes/ProtectedLayout";
import theme from "./theme";
import englishJson from "./utils/locales/en/english.json";
import romaninanJson from "./utils/locales/ro/romanian.json";

function App() {
  const userData = useSelector((state) => state.userData.user);
  const { currentLanguage } = useSelector((state) => state.translationReducer);
  const { routesToRender } = useRoleWiseRoutes();

  i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      // the translations
      // (tip move them in a JSON file and import them,
      // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
      resources: {
        en: {
          translation: englishJson[0],
        },
        ro: {
          translation: romaninanJson[0],
        },
      },
      lng: currentLanguage, // if you're using a language detector, do not define the lng option
      fallbackLng: "en",

      interpolation: {
        escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
      },
    });

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <ThemeProvider theme={theme}>
        <SnackbarProvider maxSnack={3}>
          <Routes>
            {/* Auth Routes */}

            {/* <Route element={<AuthLayout />}> */}
            {AuthRoutes.map(({ component: Component, path, id }) => (
              <Route key={id} path={path} element={Component} />
            ))}
            {/* </Route> */}

            {/* Protected Routes */}
            <Route path="/" element={<ProtectedLayout />}>
              {/* Dynamic Route Rendering Based on User Role */}
              {routesToRender.map(({ component: Component, path, id }) => (
                <Route key={id} path={path} element={Component} />
              ))}
              {/* {userData?.role === "worker"
                ? WorkerRoutes.map(({ component: Component, path, id }) => (
                    <Route key={id} path={path} element={Component} />
                  ))
                : userData?.role === "supplier"
                ? SupplierRoutes.map(({ component: Component, path, id }) => (
                    <Route key={id} path={path} element={Component} />
                  ))
                : userData?.role === "provider"
                ? CompanyRoutes.map(({ component: Component, path, id }) => (
                    <Route key={id} path={path} element={Component} />
                  ))
                : userData?.role === "education"
                ? EducationRoutes.map(({ component: Component, path, id }) => (
                    <Route key={id} path={path} element={Component} />
                  ))
                : WorkerRoutes.map(({ component: Component, path, id }) => (
                    <Route key={id} path={path} element={Component} />
                  ))} */}

              {/* Static Routes */}
              {userData?.role === "education" ? (
                <Route
                  path="/education/customer-support"
                  element={<EducationCustomerSupport />}
                />
              ) : null}
              {userData?.role === "supplier" ? (
                <Route
                  path="/supplier/sale/detail/:id"
                  element={<SupplierSalesDetail />}
                />
              ) : null}
              {userData?.role === "company" ? (
                <Route
                  path="/company/subscription/services"
                  element={<CompanyAllServicesPage />}
                />
              ) : null}
              {userData?.role === "creator" &&
              !isCreatorUnderReview(userData) ? (
                <Route
                  path="/creator/campaigns/:id"
                  element={<CreatorCampaignDetail />}
                />
              ) : null}
              {isCreatorUnderReview(userData) ? (
                <Route
                  path="/creator/*"
                  element={<Navigate to="/creator/onboarding" replace />}
                />
              ) : null}

              <Route
                path="/customer-support"
                element={<AdminCustomerSupport />}
              />
            </Route>
          </Routes>
        </SnackbarProvider>
        <SnackbarAlert
          ref={(ref) => {
            snackConst.snackRef = ref;
          }}
        />
      </ThemeProvider>
    </LocalizationProvider>
  );
}

export default App;
